export default __webpack_public_path__ + "static/mightyc-teaser4-desktop-11182d9931e6c9ad11b86e16c6c71974.svg";